import type { Project } from '@/types';

export const PROJECTS: Project[] = [
  {
    id:             'rejean',
    name:           'Rejean — Hardware Store Alerts',
    description:    'A PWA that watches promotions at hardware stores in your area and alerts you when the materials for your renovation project go on sale. AI matching between materials and deals.',
    accentColorVar: 'var(--color-anticiper)',
    tags:           ['PWA', 'Gemini API', 'Firebase FCM', 'i18n'],
  },
  {
    id:             'stackchan',
    name:           'StackChan Companion',
    description:    'An open-source IoT robot on ESP32 with animated facial expressions reacting in real time to Claude Code events. A physical assistant sitting on the desk.',
    accentColorVar: 'var(--color-ciel)',
    tags:           ['C++', 'ESP32-S3', 'PlatformIO', 'Open Source'],
  },
  {
    id:             'lecours',
    name:           'Lecours Maple Farm',
    description:    'Showcase site and online ordering for the family maple farm — products, gift boxes, seasonal orders. A tribute built with care.',
    accentColorVar: 'var(--color-ameliorer)',
    tags:           ['Firebase Auth', 'Firestore', 'HTML · CSS · JS'],
  },
  {
    id:             'rpg-textuel',
    name:           'Text RPG — AI-powered Game Master',
    description:    'A solo D&D-style text RPG where the Game Master is an AI: it narrates and improvises, but never touches the rules — every effect goes through events validated by the engine. 3D dice, tactical combat, quests, weather and a persistent world.',
    accentColorVar: 'var(--color-temps)',
    tags:           ['React · strict TS', 'Gemini API', '3D dice', 'Open Source'],
  },
  {
    id:             'sorel-techno',
    name:           'Sorel Techno — Sorel-Tracy Tech Collective',
    description:    'Website of the Sorel-Tracy technology collective, an early-stage group bringing together the region\'s tech community. A fast, accessible static site, Law 25 compliant, hosted on Firebase.',
    accentColorVar: 'var(--color-anticiper)',
    tags:           ['HTML · CSS · JS', 'Firebase Hosting', 'Accessibility', 'Early stage'],
    link:           'https://sorel-techno.web.app',
    logoSrc:        '/sorel-techno-logo.svg',
  },
  {
    id:             'petitchef',
    name:           'Petit Chef',
    description:    'An app that compares food prices across grocery stores in your area, spots the best offers and suggests smart recipes built around the cheapest ingredients.',
    accentColorVar: 'var(--color-maitrise)',
    tags:           ['React Native', 'AI', 'Firebase', 'WIP'],
  },
];
